import { OrderTypes } from '../app/pages/bulk-containers/core/enums';
import { MenuItem } from '../app/core/models/menu-item.model';

export const menuItems: MenuItem[] = [
  {
    name: 'Übersicht',
    icon: 'pie-chart',
    routerLink: '',
    isMobile: false,
    exact: true
  },
  {
    name: 'Artikel',
    icon: 'tags',
    elements: [
      {
        name: 'Übersicht',
        routerLink: '/articles',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Lagerbestand',
        routerLink: '/lagerbestand',
        isMobile: false,
        exact: true,
      },
      {
        name: 'EAN',
        routerLink: '/ean',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Mindesthaltbarkeit',
        routerLink: '/mhd',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Etiketten',
        routerLink: '/etiketten',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Rezeptkartendrucker',
        routerLink: '/recipe-cards-printer',
        isMobile: false,
        exact: false,
      }
    ]
  },
  {
    name: 'Logistik',
    icon: 'shopping-cart',
    elements: [
      {
        name: 'Offen',
        routerLink: '/orders/open',
        isMobile: false,
        exact: true
      },
      {
        name: 'Heute fertiggestellt',
        routerLink: '/orders/closed-today',
        isMobile: false,
        exact: true
      },
      {
        name: 'Bestellung versenden',
        isMobile: false,
        exact: true,
        showModal: true,
        modalRef: 'deliveryNoteProcessModal'
      },
      {
        name: 'Bestellung / Reklamation',
        routerLink: '/complaints',
        isMobile: false,
        exact: true
      },
      {
        name: 'Inventur',
        routerLink: '/inventory',
        isMobile: false,
        exact: true
      },
      {
        name: 'Lagerplatzsuche',
        isMobile: false,
        exact: true,
        showModal: true,
        modalRef: 'storagePlaceFinderModal'
      },
      {
        name: 'Lagerplätze',
        routerLink: '/slns',
        isMobile: false,
        exact: true
      },
      {
        name: 'Red List',
        routerLink: '/red-list',
        isMobile: false,
        exact: true
      },
      // {
      //   name: 'Nachfüllliste Hauptlager',
      //   routerLink: '/flour/restocks-main-warehouse',
      //   isMobile: false,
      //   exact: true
      // }
    ],
    isOpen: false
  },
  {
    name: 'Lagerhäuser',
    icon: 'database',
    elements: [
      {
        name: 'Umlagerungen',
        routerLink: '/stock-transfer',
        isMobile: false,
        exact: true,
      },
      {
        name: 'MHD Angebote',
        routerLink: '/mhd-offers',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Eingang',
        isMobile: false,
        exact: true,
        showModal: true,
        modalRef: 'stockTransferProcessModal',
        modalParam: {type: 1}
      },
      {
        name: 'Ausgang',
        isMobile: false,
        exact: true,
        showModal: true,
        modalRef: 'stockTransferProcessModal',
        modalParam: {type: 0}
      },
    ],
    isOpen: false
  },
  {
    name: 'Produktion',
    icon: 'build',
    elements: [
      {
        name: 'Tagesgeschäft',
        isGroupLabel: true,
      },
      {
        name: 'Übersicht',
        routerLink: '/production-planning/overview',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Produktionsaufträge',
        routerLink: '/production-planning/orders',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Planung',
        routerLink: '/production-planning/plan',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Abarbeiten',
        routerLink: '/production-planning/execution',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Material',
        isGroupLabel: true,
      },
      {
        name: 'Grundstoffe',
        routerLink: '/production-planning/grundstoffe',
        isMobile: false,
        exact: false,
      },
      {
        name: 'Mischungen',
        routerLink: '/production-planning/mischungen',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Stammdaten',
        isGroupLabel: true,
      },
      {
        name: 'Rezepturen',
        routerLink: '/production-planning/recipes',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Produktionsartikel',
        routerLink: '/production-articles',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Produktionsstammdaten',
        routerLink: '/production-planning/master-data',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Sonstiges',
        isGroupLabel: true,
      },
      {
        name: 'Geschenksets produzieren',
        routerLink: '/giftbox-production',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Alt (wird abgelöst)',
        isGroupLabel: true,
      },
      {
        name: 'Produktionsaufträge (alt)',
        routerLink: '/production-orders',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Prozessieren (alt)',
        isMobile: false,
        exact: true,
        showModal: true,
        modalRef: 'productionOrderProcessModal'
      },
      {
        name: 'Mischungen (alt)',
        routerLink: '/own-production',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Bestellplanung (alt)',
        routerLink: '/planning-production',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Lagerhaus Übersicht (alt)',
        routerLink: '/storestocks',
        isMobile: false,
        exact: true,
      },
    ],
    isOpen: false
  },
  {
    name: 'Einkauf',
    icon: 'shopping',
    elements: [
      {
        name: 'Fremdmarke',
        routerLink: '/bulk-containers/non-packing',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Bestellungen - Fremdmarke',
        routerLink: `/bulk-containers/orders?orderType=${ OrderTypes.NonPacking }`,
        isMobile: false,
        exact: true,
      },
      {
        name: 'Lieferanten',
        routerLink: '/suppliers',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Neuanlage Artikel',
        routerLink: '/product-setups',
        isMobile: false,
        exact: true,
      },
    ],
    isOpen: false
  },
  {
    name: 'Berichte',
    icon: 'file',
    elements: [
      {
        name: 'Flour Übersicht',
        routerLink: '/reports/flour-review',
        exact: true,
      },
      {
        name: 'Artikelstammdaten',
        routerLink: '/reports/product-master',
        exact: true,
      },
      {
        name: 'Kartonverbrauch',
        routerLink: '/reports/carton-consumption',
        exact: true,
      }
    ],
    isOpen: false
  },

  {
    name: 'Marketing',
    icon: 'pie-chart',
    elements: [
      {
        name: 'E-Mail-Unterschrift',
        routerLink: '/marketing/email-signature',
        exact: true,
      },
      {
        name: 'Geschenkgutscheine',
        routerLink: '/marketing/vouchers',
        exact: true,
      },
      {
        name: 'Plakate',
        routerLink: '/posters',
        exact: true,
      },
      {
        name: 'Rezeptkarten-Finder',
        routerLink: '/marketing/recipe-card-finder',
        exact: true,
      },
    ],
    isOpen: false
  },
  {
    name: 'Seminare',
    icon: 'calendar',
    elements: [
      {
        name: 'Übersicht',
        routerLink: '/seminars/overview',
        exact: true,
      },
      {
        name: 'Bestellungen',
        routerLink: '/seminars/orders',
        exact: true,
      },
      {
        name: 'Kategorien',
        routerLink: '/seminars/categories',
        exact: true,
      },
      {
        name: 'Warteraum',
        routerLink: '/seminars/waiting-room',
        exact: true,
      },
      {
        name: 'Seminare Hechendorf',
        routerLink: '/seminars/hechendorf',
        exact: true,
      },
      {
        name: 'Seminare München',
        routerLink: '/seminars/munchen',
        exact: true,
      },
      {
        name: 'Seminare Nürnberg',
        routerLink: '/seminars/nurnberg',
        exact: true,
      },
      {
        name: 'Seminare Salzburg',
        routerLink: '/seminars/salzburg',
        exact: true,
      },
      {
        name: 'Seminare Münster',
        routerLink: '/seminars/muenster',
        exact: true,
      },
    ],
    isOpen: false
  },
  {
    name: 'Controlling',
    icon: 'control',
    elements: [
      {
        name: 'Bestände',
        routerLink: '/controlling/stocks',
        exact: true,
      },
      {
        name: 'Produktion',
        routerLink: '/controlling/production',
        exact: true,
      },
      {
        name: 'Grundstoffe',
        routerLink: '/controlling/bulk-container',
        exact: true
      },
      {
        name: 'Fremdmarke',
        routerLink: '/controlling/non-packing',
        exact: true
      },
      // {
      //   name: 'Preise',
      //   routerLink: '/controlling/prices',
      //   exact: true
      // },
      {
        name: 'Auswertung Verkauf',
        routerLink: '/controlling/sales-evaluation',
        exact: true
      }
    ],
    isOpen: false
  },
  {
    name: 'Läden',
    icon: 'shop',
    elements: [
      {
        name: 'Dateien',
        routerLink: '/store-photos',
        isMobile: false,
        exact: true,
      },
    ],
    isOpen: false
  },
  {
    name: 'Einstellungen',
    icon: 'setting',
    elements: [
      {
        name: 'Allgemein',
        routerLink: '/settings/general',
        exact: true,
      },
      {
        name: 'Neuanlage Schritte',
        routerLink: '/settings/product-setup-steps',
        exact: true,
      },
      {
        name: 'E-Mail-Versand',
        routerLink: '/settings/mail',
        exact: true,
      },
      {
        name: 'Mitarbeiter',
        routerLink: '/users',
        exact: true,
      },
      {
        name: 'Lagerhäuser',
        routerLink: '/stores',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Kartons',
        routerLink: '/cartons',
        exact: true,
      },
      {
        name: 'Verpackungskosten',
        routerLink: '/settings/packaging-costs',
        exact: true,
      },
    ],
    isOpen: false
  },
  {
    name: 'Werkzeuge',
    icon: 'tool',
    elements: [
      {
        name: 'Linkverkürzer',
        routerLink: '/tools/link-shortener',
        isMobile: false,
        exact: true,
      },
      {
        name: 'Exporte',
        routerLink: '/tools/exports',
        exact: true,
      },
    ]
  }
];
